let cache = null;

export const setSessionCache = (data) => {
    cache = data;
};

export const getSessionCache = () => cache;

export const clearSessionCache = () => {
    cache = null;
};
